import * as tslib_1 from "tslib";
import * as _ from 'lodash';
import { Injector, OnDestroy } from '@angular/core';
import { CreditCardFormService } from 'src/app/shared/modules/components/credit-card-form/credit-card-form.service';
import { CreditCardErrorsMessages, CreditCardErrorsTitle } from 'src/app/shared/modules/components/credit-card-form/enum/errors.enum';
import { FeedbackModal } from 'src/app/shared/modules/components/modals/feedback-modal/feedback-modal.class';
import { ConfigService } from 'src/app/shared/services/config/config.service';
import { InjectorService } from 'src/app/shared/services/injector/injector.service';
import { TokenizeTemplate } from './tokenize-template.class';
var TokenizeComponent = /** @class */ (function () {
    function TokenizeComponent() {
        var _this = this;
        this.numberOfMethods = 0;
        var injector = InjectorService.get();
        Object.assign(this, {
            _creditCard: injector.get(ConfigService).booking.creditCard,
            _creditCardFormService: injector.get(CreditCardFormService),
            feedback: {
                error: new FeedbackModal({
                    cta: { slug: 'understood', params: {}, action: function () { return _this.feedback.error.close(); } },
                    description: { slug: 'tokenize-credit-card-error-description', params: {} },
                    icon: 'avc-cross-circle',
                    title: { slug: 'tokenize-credit-card-error-title', params: {} }
                }),
                success: new FeedbackModal({
                    cta: { slug: 'understood', params: {}, action: function () { return _this.feedback.success.close(); } },
                    description: { slug: 'tokenize-credit-card-success-description', params: {} },
                    icon: 'avc-check-circle',
                    title: { slug: 'tokenize-credit-card-success-title', params: {} }
                }),
                loading: new FeedbackModal({
                    description: { slug: 'loading-purchase-description', params: {} },
                    loader: true,
                    title: { slug: '', params: {} }
                })
            },
            template: new TokenizeTemplate(),
            companyPhone: injector.get(ConfigService).company.phone,
            paymentConfig: injector.get(ConfigService).booking.resume.paymentConfig,
            configService: injector.get(ConfigService)
        });
        this.setConfig();
        this.setCta();
        this.setSubscribers();
        this.numberOfMethods = (this.config) ? this.config.waysOfPay.numberOfMethods : 0;
        if (this.paymentConfig.gatewayCode === 'mercadopago') {
            this.loadMercadoPagoScript();
        }
    }
    TokenizeComponent.prototype.setConfig = function () {
        var _a = InjectorService.get().get(ConfigService), project = _a.project, config = tslib_1.__rest(_a, ["project"]);
        this.config = _.get(config[project], 'config.config');
    };
    TokenizeComponent.prototype.ngOnDestroy = function () {
        if (this.subscribers) {
            this.subscribers.forEach(function (s) { return s.unsubscribe(); });
        }
    };
    TokenizeComponent.prototype.setSubscribers = function () {
        var _this = this;
        var screen = InjectorService.get().get(ConfigService).screen;
        var subscribers = [
            screen.onIsXSChanges().subscribe(function (r) {
                _this.isXS = r;
            }),
            screen.onWindowResizeChanges().subscribe(function () { return _this.screenWidth = screen.width; })
        ];
        Object.assign(this, {
            isXS: screen.isXS,
            screenWidth: screen.width,
            subscribers: subscribers
        });
    };
    TokenizeComponent.prototype.setCta = function () {
        var _this = this;
        this.cta = {
            next: {
                handler: function () { return _this.onCta(); },
                text: 'add'
            },
            back: {
                hide: true
            }
        };
    };
    TokenizeComponent.prototype.onFormChanges = function (params) {
        this._form = params.form;
    };
    Object.defineProperty(TokenizeComponent.prototype, "form", {
        get: function () {
            return this._form;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TokenizeComponent.prototype, "creditCardFormService", {
        get: function () {
            return this._creditCardFormService;
        },
        enumerable: true,
        configurable: true
    });
    TokenizeComponent.prototype.onCta = function () {
        if (this._form.invalid) {
            this.errors = tslib_1.__assign({}, this.errors, { form: true });
            return;
        }
        this._tokenize(false);
    };
    TokenizeComponent.prototype.tokenize = function (showLoading) {
        if (showLoading === void 0) { showLoading = false; }
        this._tokenize(showLoading);
    };
    TokenizeComponent.prototype._setBillingAddress = function (billingAddress) {
        var _this = this;
        this.creditCardFormService.updateBillingAddress({ billingAddress: billingAddress }).subscribe(function (res) { return _this.onSuccess('tokenize', res); }, function (error) { return _this.onError('tokenize', error); });
    };
    TokenizeComponent.prototype._tokenize = function (showLoading) {
        var _this = this;
        var value = this._form.getRawValue();
        var billingAddress = tslib_1.__assign({}, (value.address) && { street: value.address }, (value.city) && { city: (typeof value.city === 'object') ? value.city.value : value.city }, (value.region) && { province: (typeof value.region === 'object') ? value.region.value : value.region }, (value.postalCode) && { postalCode: value.postalCode }, (value.phoneNumber) && { phoneNumber: value.phoneNumber }, (value.country) && { country: value.country }, (value.firstname) && { firstname: value.firstname }, (value.lastname) && { lastname: value.lastname }, (value.email) && { email: value.email });
        this.loading = true;
        if (showLoading) {
            this.feedback.loading.open();
        }
        this.creditCardFormService.tokenize(tslib_1.__assign({}, (Object.keys(billingAddress).length > 0) && { billingAddress: billingAddress }, { creditCard: {
                expiryDate: ("0" + value.month + ("" + value.year).slice(-2)).slice(-4),
                name: value.name,
                number: value.pan.replace(/\s+/g, ''),
                cvc: value.cvc
            } })).subscribe(function (res) { return _this.onSuccess('tokenize', res); }, function (error) { return _this.onError('tokenize', error); });
    };
    TokenizeComponent.prototype._handleCheckoutRedirect = function () {
        var _a = this.config, sourceApp = _a.sourceApp, selectedPayment = _a.selectedPayment;
        var _b = this.configService, booking = _b.booking, return_url = _b.return_url;
        var creditCardId = this._creditCard.id;
        if (sourceApp === 'olb') {
            var hashedBookingId = btoa(String(booking.id));
            var hashedTokenId = btoa(String(creditCardId));
            var deviceId = window.MP_DEVICE_SESSION_ID;
            var url = return_url + "reservarAlojamiento.php?booking_id=" + hashedBookingId + "&token_id=" + hashedTokenId;
            if (selectedPayment) {
                var hashedPaymentId = btoa(String(selectedPayment.id));
                url += "&payment_id=" + hashedPaymentId;
            }
            if (deviceId) {
                var hashedDeviceId = btoa(deviceId);
                url += "&deviceId=" + hashedDeviceId;
            }
            window.location.href = url;
        }
        if (sourceApp === 'checkin') {
            window.location.href = "" + return_url;
        }
        if (sourceApp === 'intranet') {
            window.location.href = "" + return_url;
        }
    };
    TokenizeComponent.prototype.onSuccess = function (operation, value) {
        this._onSuccess(operation, value);
        if (this.configService.project === 'checkout') {
            this._handleCheckoutRedirect();
        }
    };
    TokenizeComponent.prototype._onSuccess = function (operation, value) {
        this.loading = false;
        this.feedback.loading.close();
        this.feedback.success.open();
        if (value.display) {
            this.creditCard.set({
                updatable: value.canChange,
                number: value.display,
                type: value.scheme,
                owner: tslib_1.__assign({ name: value.holder }, (value.billingAddress || {}))
            });
            return;
        }
        this.creditCard.setBillingAddress(value);
    };
    TokenizeComponent.prototype.onError = function (operation, error) {
        this._onError(operation, error);
    };
    TokenizeComponent.prototype._onError = function (operation, error) {
        this.loading = false;
        this.feedback.error.set({
            description: {
                slug: CreditCardErrorsMessages[error] || 'error-try-contact',
                params: {
                    amount: (operation === 'purchase') ? this.template.getAmountTranslation() : 0,
                    phone: this.companyPhone
                }
            },
            title: {
                slug: CreditCardErrorsTitle[error] || 'error-processing-transaction',
                params: {}
            }
        });
        this.feedback.loading.close();
        this.feedback.error.open();
    };
    Object.defineProperty(TokenizeComponent.prototype, "creditCard", {
        get: function () {
            return this._creditCard;
        },
        enumerable: true,
        configurable: true
    });
    TokenizeComponent.prototype.backHome = function () {
        this.configService[this.configService.project].goHome();
    };
    TokenizeComponent.prototype.loadMercadoPagoScript = function () {
        return new Promise(function (resolve, reject) {
            var node = document.createElement('script');
            node.src = 'https://www.mercadopago.com/v2/security.js';
            node.type = 'text/javascript';
            node.async = false;
            node.setAttribute('view', 'checkout');
            node.onload = function () { return resolve(); };
            node.onerror = function () { return reject(console.error('Failed on MP device')); };
            document.getElementsByTagName('head')[0].appendChild(node);
        });
    };
    return TokenizeComponent;
}());
export { TokenizeComponent };
